export default "__VITE_ASSET__BgjVAQPl__"